export default __webpack_public_path__ + "static/media/web_proj.85c3a870.png";